import { TBillingAdditionalPlanCode } from './types';

export enum EBillingPlanCode {
  shipper = 'tms.plan.shipper',
  carrierBasic = 'tms.plan.carrier.basic',
  carrierExtended = 'tms.plan.carrier.extended',
  carrierStart = 'tms.plan.carrier.start',
  freightForwarderBasic = 'tms.plan.freight_forwarder.basic',
  freightForwarderExtended = 'tms.plan.freight_forwarder.extended',
  cargoOwner = 'tms.plan.cargo_owner',
}

export enum EBillingShortPlanCode {
  basic = 'basic',
  extended = 'extended',
  start = 'start',
}

export enum EBillingPlanGroup {
  shipper = 'shipper',
  carrier = 'carrier',
  freightForwarder = 'freight_forwarder',
  cargoOwner = 'cargo_owner',
}

export enum EBillingPlanCodeStatus {
  active = 'active',
  pending = 'pending',
}

export enum EBillingTransactionCode {
  countOfCompletedExecutionRequests = 'tms.count_of_completed_execution_requests',
  countOfCompletedBookings = 'tms.count_of_completed_bookings',
  countOfCompletedRuns = 'tms.count_of_completed_runs',
}

export enum ETenantSubscriptionsEventType {
  subscriptionPlanUpdated = 'billing_context.subscription_plan_updated',
  subscriptionTerminationCompleted = 'billing_context.subscription_termination_completed',
}

export enum EBillingContextErrorCode {
  insufficientFunds = 'billing_context.insufficient_funds',
}

export enum EBillingBalanceEventType {
  /** Пополнение баланса/свершение транзакции */
  walletTransactionCreated = 'billing_context.wallet_transaction_created',
  /** Значение баланса изменилось */
  walletBalanceRefreshed = 'billing_context.wallet_balance_refreshed',
}

export const additionalOpenClosedBiddingPlanCode: TBillingAdditionalPlanCode = 'tms.add_on.open_closed_bidding';
